import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import PeriodReports from "../../../../Components/Page/Settings/Company/PeriodReports";
import { getYearEndPeriodList } from "../../../../store/YearEndPeriod/action";

export default function YearEndPeriod({ page }) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getYearEndPeriodList());
  }, []);
  const { yearEndPeriodListAPI } = useSelector((state) => ({
    yearEndPeriodListAPI:
      state.YearEndPeriod.yearEndPeriodList?.yearendperiod_list,
  }));
  return (
    <>
      <PeriodReports
        data={yearEndPeriodListAPI}
        page={page}
        reportName={"yearEndPeriod"}
      />
    </>
  );
}
